<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Add Playlist</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="playlist.name">
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" >Submit</button>
          <router-link :to="{ name: 'PlaylistsIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      playlist: {
        playlist_id: 0,
        site_id: 0,
        name: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      scoped_site_id: 'scopedSiteId'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditPlaylist', this.playlist)
    }
  }
}
</script>

<style scoped>

</style>
